import { Theme } from '@material-ui/core';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const styles = ({ spacing }: Theme) => {
    return {
        root: {
            margin: spacing(1),
        },
        mainBanner: {
        },
        subBanner: {
        },
    };
};

export default styles;